<template>
  <div class="authorIntro">
    <div class="authors" v-for="(item, index) in dataList" :key="index">
      <div class="author-info">
        <div class="author-avatar flex-center">
          <img :src="item.authorPortrait ? item.authorPortrait : defaultImg" alt="" />
        </div>
        <div class="right-info">
          <div class="name">{{ item.authorName }}</div>
          <div class="infos">
            <div class="nation">
              <span>国籍：</span>
              <span class="ellipsis-aRow">{{
                item.nationality == null || item.nationality == ""
                  ? "-"
                  : item.nationality
              }}</span>
            </div>
            <div>
              <span>学术领域：</span>
              <el-tooltip
                :content="item.academicField"
                placement="top"
                v-ak-tooltip-auto-show
              >
                <span class="ellipsis-aRow">{{
                  item.academicField == null || item.academicField == ""
                    ? "-"
                    : item.academicField
                }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="infos">
            <div class="nation">
              <span>民族：</span>
              <span class="ellipsis-aRow">{{
                item.nation == null || item.nation == "" ? "-" : item.nation
              }}</span>
            </div>
            <div>
              <span>机构：</span>
              <el-tooltip
                :content="item.cpName"
                placement="top"
                v-ak-tooltip-auto-show
              >
                <span class="ellipsis-aRow">{{
                  item.cpName == null || item.cpName == "" ? "-" : item.cpName
                }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="author-story">{{ item.introduction }}</div>
      <el-divider></el-divider>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      defaultImg: require("@/assets/images/default-avatar.jpg"),
    };
  },
  props: {
    dataList: Array,
  },
};
</script>
<style scoped lang='scss'>
.authorIntro {
  box-sizing: border-box;
  padding: 8px 0px 20px;
  // .authors {
  //   margin-bottom: 20px;
  // }
  // .authors:last-of-type {
  //   margin-bottom: 5px;
  // }
  .author-info {
    display: flex;
    align-items: center;
    .author-avatar {
      width: 160px;
      height: 160px;
      margin-right: 40px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .right-info {
      width: 560px;
      .name {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-bottom: 30px;
      }
      .infos {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 21px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        > div {
          display: flex;
          flex: 1;
          span:last-child {
            max-width: 160px;
          }
        }
        .nation {
          // margin-right: 160px;
          span:last-child {
            max-width: 130px;
          }
        }
      }
    }
  }
  .author-story {
    width: 960px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    // max-height: 880px;
    margin-top: 20px;
  }
}
.el-divider--horizontal {
  margin: 18px 0;
}
</style>
